import { equals, isEntity } from '@softline/core';
import { FilterItemConfig } from '../types/filter-config';

/**
 * Element equality for in/notIn values - core's `equals`: entities by id (a re-fetched option is
 * a new object), other objects structurally regardless of key order, primitives by identity.
 */
export function filterValuesEqual<T extends object>(
  _config: FilterItemConfig<T>,
  a: unknown,
  b: unknown
): boolean {
  return equals(a, b);
}

/** stable string identity of an in/notIn element, consistent with filterValuesEqual */
export function filterValueKey<T extends object>(_config: FilterItemConfig<T>, value: unknown): string {
  if (value !== null && typeof value === 'object') {
    if (isEntity(value)) return String(value.id);
    return stableStringify(value);
  }
  return String(value);
}

// key order must not change the identity: {a,b} and {b,a} are the same element to equals()
function stableStringify(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`;
  if (value !== null && typeof value === 'object') {
    const entries = Object.keys(value as object)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${stableStringify((value as Record<string, unknown>)[key])}`);
    return `{${entries.join(',')}}`;
  }
  return JSON.stringify(value) ?? 'undefined';
}
